import React, { Component } from "react";

import swal from "sweetalert";
import axios from "axios";
import { Field, formInputData, formValidation } from "reactjs-input-validator";
//import {navigate } from "gatsby";

export default class Form extends Component {
  constructor() {
    super();
    this.state = {
      data: {
        Category: {
          value: "none",
          valid: true
        },
        CouncilChange: {
          value: "none",
          valid: true
        },
        educationChange: {
          value: "none",
          valid: true
        }
      }
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCouncilChange = this.handleCouncilChange.bind(this);
    this.handleCategoryChange = this.handleCategoryChange.bind(this);
    this.handleeducationChange = this.handleeducationChange.bind(this);
  }

  handleChange(event, inputValue, inputName, validationState, isRequired) {
    const value = (event && event.target.value) || inputValue;
    const { data } = this.state;
    data[inputName] = { value, validation: validationState, isRequired };
    this.setState({
      data
    });
    // if you want access to your form data
    const formData = formInputData(this.state.data); // eslint-disable-line no-unused-vars
    // tells you if the entire form validation is true or false
    const isFormValid = formValidation(this.state.data); // eslint-disable-line no-unused-vars
  }

  handleCategoryChange(e) {
    e.preventDefault();
    let data = this.state.data;
    data.Category.value = e.target.value;
    if (e.target.value === "none") data.Category.valid = false;
    else data.Category.valid = true;
    this.setState({ data });
  }

  handleCouncilChange(e) {
    e.preventDefault();
    let data = this.state.data;
    data.CouncilChange.value = e.target.value;
    if (e.target.value === "none") data.CouncilChange.valid = false;
    else data.CouncilChange.valid = true;
    this.setState({ data });
  }

  handleeducationChange(e) {
    e.preventDefault();
    let data = this.state.data;
    data.educationChange.value = e.target.value;
    if (e.target.value === "none") data.educationChange.valid = false;
    else data.educationChange.valid = true;
    this.setState({ data });
  }

  handleSubmit(event) {
    event.preventDefault();
    const isFormValid = formValidation(this.state.data);
    if (isFormValid) {
      // do anything including ajax calls
      this.setState({ callAPI: true });
      if (isFormValid) {
        var dataobj = {
          firstName: this.state.data.firstName.value,
          lastName: this.state.data.lastName.value,
          dob: this.state.data.dob.value,
          userName: this.state.data.userName.value,
          password: this.state.data.password.value,
          mobileNumber: this.state.data.phone.value,
          emailId: this.state.data.email.value,
          selectcategory: this.state.data.Category
            ? this.state.data.Category.value
            : "",
          cousellingreq: this.state.data.CouncilChange
            ? this.state.data.CouncilChange.value
            : "",
          equcationqualification: this.state.data.educationChange.value,
          aboutme: this.state.data.about.value,
          hobbies: this.state.data.hobbies.value
        };
        axios
          .post(
            `https://s3b9ssq57b.execute-api.ap-south-1.amazonaws.com/dev/registration`,
            dataobj
          )
          .then(res => {
            console.log("response", res);
            if (res.data.statuscode === 200) {
              swal({
                title: "Success",
                text: "Thank you",
                icon: "success",
                dangerMode: true
             
              }).then(function() {
                window.location = "/";
            });
            } else
             if(res.data.statuscode === 302)
             {
              swal({
                title: "Email Exist",
                text: "Please Try with Different Email",
                icon: "warning",
                dangerMode: true
              }).then(function() {
                window.location = "register";
            });
            }
          })
          .catch(function(error) {
            swal("Oops!", "Something went wrong please try agin Later");
          });
      }
    } else {
      this.setState({ callAPI: true, shouldValidateInputs: !isFormValid });
    }
  }

  render() {
    const passwordValue =
      this.state.data.password && this.state.data.password.value;

    return (
      <form className="example">
        <div className="row m-0 pt-4">
          <div className="col-md-6">
            <Field
              validator="isAlpha"
              required
              name="firstName"
              placeholder={
                this.props.isKannada ? "ಮೊದಲ ಹೆಸರು*" : "First name*"
              }
              onChange={this.handleChange}
              value={this.state.data.firstName}
              shouldValidateInputs={this.state.shouldValidateInputs}
              className="PiFormBox"
              maxLength="15"
            />
          </div>
          <div className="col-md-6 pb-3">
            <Field
              validator="isAlpha"
              required
              name="lastName"
              placeholder={
                this.props.isKannada ? "ಕೊನೆಯ ಹೆಸರು*" : "Last name*"
              }
              onChange={this.handleChange}
              value={this.state.data.lastName}
              shouldValidateInputs={this.state.shouldValidateInputs}
              className="PiFormBox"
              maxLength="15"
            />
          </div>
          <div className="col-md-6  pb-3">
            <Field
              type="date"
              required
              name="dob"
              placeholder={
                this.props.isKannada
                  ? "ಹುಟ್ಟಿದ ದಿನಾಂಕ*"
                  : "Date of birth  (DD  -  MM  -  YYYY) *"
              }
              onChange={this.handleChange}
              value={this.state.data.dob}
              shouldValidateInputs={this.state.shouldValidateInputs}
              className="PiFormBox"
            />
          </div>
          <div className="col-md-6">
            <Field
              required
              name="userName"
              placeholder={
                this.props.isKannada ? "ಬಳಕೆದಾರ ಹೆಸರು*" : "Username*"
              }
              onChange={this.handleChange}
              value={this.state.data.userName}
              shouldValidateInputs={this.state.shouldValidateInputs}
              className="PiFormBox"
            />
          </div>
          <div className="col-md-6">
            <Field
              required
              type="password"
              name="password"
              placeholder={this.props.isKannada ? "ಪಾಸ್ವರ್ಡ್*" : "Password*"}
              onChange={this.handleChange}
              value={this.state.data.password}
              shouldValidateInputs={this.state.shouldValidateInputs}
              className="PiFormBox"
              maxLength="20"
              minLength="6"
            />
          </div>
          <div className="col-md-6  pb-3">
            <Field
              validator="isNumeric"
              required
              name="phone"
              placeholder={
                this.props.isKannada ? "ಮೊಬೈಲ್ ನಂಬರ*" : "Mobile number*"
              }
              onChange={this.handleChange}
              value={this.state.data.phone}
              shouldValidateInputs={this.state.shouldValidateInputs}
              className="PiFormBox"
              maxLength="10"
              minLength="10"
            />
          </div>
          <div className="col-md-6  pb-3">
            <Field
              validator="isEmail"
              required
              name="email"
              placeholder={this.props.isKannada ? "ಇಮೇಲ್*" : "Email id*"}
              onChange={this.handleChange}
              value={this.state.data.email}
              shouldValidateInputs={this.state.shouldValidateInputs}
              className="PiFormBox"
            />
          </div>
          <div className="col-md-6  pb-3">
            <select
              name="Category"
              required
              className="form-control PiFormBox"
              onChange={this.handleCategoryChange}
              value={
                this.state.data.Category
                  ? this.state.data.Category.value
                  : "none"
              }
            >
              <option selected="selected" value="none" hidden>
                {this.props.isKannada
                  ? "ನಿಮ್ಮ ವರ್ಗವನ್ನು ಆಯ್ಕೆಮಾಡಿ*"
                  : "Select Your Category*"}
              </option>
              <option value={this.props.isKannada ? "ವರ್ಗ-3-ಬಿ" : "Cat-3B"}>
                {this.props.isKannada ? "ವರ್ಗ-3-ಬಿ" : "Cat-3B"}
              </option>
              <option value={this.props.isKannada ? "ಸಾಮಾನ್ಯ ವರ್ಗಗಳು" : "GM"}>
                {this.props.isKannada ? "ಸಾಮಾನ್ಯ ವರ್ಗಗಳು" : "GM"}
              </option>
              <option value={this.props.isKannada ? "ಪರಿಶಿಷ್ಟ ಪಂಗಡಗಳು" : "ST"}>
                {this.props.isKannada ? "ಪರಿಶಿಷ್ಟ ಪಂಗಡಗಳು" : "ST"}
              </option>
              <option value={this.props.isKannada ? "ಪರಿಶಿಷ್ಟ ಜಾತಿ" : "SC"}>
                {this.props.isKannada ? "ಪರಿಶಿಷ್ಟ ಜಾತಿ" : "SC"}
              </option>
              <option value={this.props.isKannada ? "ವರ್ಗ 1" : "Cat-1"}>
                {this.props.isKannada ? "ವರ್ಗ 1" : "Cat-1"}
              </option>
              <option value={this.props.isKannada ? "ವರ್ಗ 2ಎ" : "Cat-2A"}>
                {this.props.isKannada ? "ವರ್ಗ 2ಎ" : "Cat-2A"}
              </option>
              <option value={this.props.isKannada ? "ವರ್ಗ 2ಬಿ" : "Cat-2B"}>
                {this.props.isKannada ? "ವರ್ಗ 2ಬಿ" : "Cat-2B"}
              </option>
              <option value={this.props.isKannada ? "ವರ್ಗ 3ಎ" : "Cat-3A"}>
                {this.props.isKannada ? "ವರ್ಗ 3ಎ" : "Cat-3A"}
              </option>
            </select>
            {this.state.data.Category.valid ? (
              ""
            ) : (
              <div>
                <span className="help-block">Please select any Category</span>
              </div>
            )}
          </div>

          <div className="col-md-6  pb-3">
            <select
              name="Council"
              required
              className="form-control PiFormBox"
              onChange={this.handleCouncilChange}
              value={
                this.state.data.CouncilChange
                  ? this.state.data.CouncilChange.value
                  : "none"
              }
            >
              <option value="none" selected="selected" hidden>
                {this.props.isKannada
                  ? "ಯಾರ ಕಡೆಗೆ ಕೌನ್ಸೆಲಿಂಗ್ ಅಗತ್ಯವಿದೆ*"
                  : "Counselling required towards*"}
              </option>
              <option
                value={
                  this.props.isKannada ? "ಉನ್ನತ ಶಿಕ್ಷಣ" : "Higher Education"
                }
              >
                {this.props.isKannada ? "ಉನ್ನತ ಶಿಕ್ಷಣ" : "Higher Education"}
              </option>
              <option
                value={
                  this.props.isKannada ? "ಉದ್ಯೋಗ ಅವಕಾಶ" : "Job Opportunities"
                }
              >
                {this.props.isKannada ? "ಉದ್ಯೋಗ ಅವಕಾಶ" : "Job Opportunities"}
              </option>
              <option
                value={
                  this.props.isKannada ? "ಕೌಶಲ್ಯ ತರಬೇತಿ" : "Skill Training"
                }
              >
                {this.props.isKannada ? "ಕೌಶಲ್ಯ ತರಬೇತಿ" : "Skill Training"}
              </option>
              <option
                value={this.props.isKannada ? "ವಿದ್ಯಾರ್ಥಿವೇತನ" : "Scholarship"}
              >
                {this.props.isKannada ? "ವಿದ್ಯಾರ್ಥಿವೇತನ" : "Scholarship"}
              </option>
              <option value={this.props.isKannada ? "ಸಾಲ" : "Loans"}>
                {this.props.isKannada ? "ಸಾಲ" : "Loans"}
              </option>
            </select>
            {this.state.data.CouncilChange.valid ? (
              ""
            ) : (
              <div>
                <span className="help-block">Please select any Council</span>
              </div>
            )}
          </div>

          <div className="col-md-6  pb-3">
            <select
              name="education"
              required
              className="form-control PiFormBox"
              onChange={this.handleeducationChange}
              value={
                this.state.data.educationChange
                  ? this.state.data.educationChange.value
                  : "none"
              }
            >
              <option value="none" selected="selected" hidden>
                {this.props.isKannada
                  ? "ಶಿಕ್ಷಣ ಅರ್ಹತೆ*"
                  : "Education Qualification*"}
              </option>
              <option value={this.props.isKannada ? "10ನೇ ಪಾಸ್" : "10th Pass"}>
                {this.props.isKannada ? "10ನೇ ಪಾಸ್" : "10th Pass"}
              </option>
              <option value={this.props.isKannada ? "12ನೇ ಪಾಸ್" : "12th Pass"}>
                {this.props.isKannada ? "12ನೇ ಪಾಸ್" : "12th Pass"}
              </option>
              <option value={this.props.isKannada ? "ಪದವಿಧರ" : "Graduate"}>
                {this.props.isKannada ? "ಪದವಿಧರ" : "Graduate"}
              </option>
              <option
                value={this.props.isKannada ? "ಸ್ನಾತಕೋತ್ತರ" : "Post Graduate"}
              >
                {this.props.isKannada ? "ಸ್ನಾತಕೋತ್ತರ" : "Post Graduate"}
              </option>
              <option value={this.props.isKannada ? "ಇತರರು" : "Others"}>
                {this.props.isKannada ? "ಇತರರು" : "Others"}
              </option>
            </select>
            {this.state.data.educationChange.valid ? (
              ""
            ) : (
              <div>
                <span className="help-block">
                  Please select any Education Details
                </span>
              </div>
            )}
          </div>
          <div className="col-md-6  pb-3">
            <Field
              required
              type="text"
              name="about"
              placeholder={
                this.props.isKannada
                  ? "ನನ್ನ ಬಗ್ಗೆ (ಗರಿಷ್ಠ 25 ಪದಗಳು)*"
                  : "About me* (25 words max)"
              }
              onChange={this.handleChange}
              value={this.state.data.about}
              shouldValidateInputs={this.state.shouldValidateInputs}
              className="PiFormBox"
              maxLength="200"
            />
          </div>
          <div className="col-md-6  pb-3">
            <Field
              required
              name="hobbies"
              placeholder={this.props.isKannada ? "ಹವ್ಯಾಸಗಳು*" : "Hobbies*"}
              onChange={this.handleChange}
              value={this.state.data.hobbies}
              shouldValidateInputs={this.state.shouldValidateInputs}
              className="PiFormBox"
              maxLength="200"
            />
          </div>

          <div className="col-12 text-center pt-2 pb-2 pr-0 pl-0">
            <div class="registerbtn">
              <button
                type="submit"
                className="regbtn"
                onClick={this.handleSubmit}
              >
                {this.props.isKannada ? "ನೋಂದಣಿ ಮಾಡಿ" : "Register now"}
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}
